import { Controller } from "@hotwired/stimulus"

// Fills a typeahead menu from the server instead of from the markup around it.
//
// Every other menu in the rail ships its options with the page and filters them in the browser,
// which is the right trade for a list of request types. Change sender's list is everyone who has
// ever written in, and shipping it with the page meant shipping it with every thread the reader
// opened — tens of megabytes of <button> per switch on a mature inbox, which was the greater part
// of FRO-100's "switching threads feels slow".
//
// So: nothing until the menu is opened, and a fresh page of matches as the reader types. The frame
// does the fetching and the swapping; this only decides what its src should be, which is why
// there is no request state to track here. Turbo ignores a src set to what it already is, so
// reopening a menu nobody has typed in costs nothing.
const DEBOUNCE = 150

export default class extends Controller {
  static targets = [ "menu", "frame" ]
  static values = { url: String }

  disconnect() {
    clearTimeout(this.timer)
  }

  // Both halves of the toggle land here; only opening is interesting. Closing deliberately leaves
  // the rows in place rather than emptying the frame, so reopening shows something immediately
  // instead of flashing empty while the same request is made again.
  toggled() {
    if (this.menuTarget.hidden) return

    this.fetch("")
  }

  // Debounced because this is a keystroke handler on a text field and each call is a round trip.
  // Short enough that it still reads as filtering rather than searching.
  search(event) {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.fetch(event.target.value), DEBOUNCE)
  }

  fetch(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query.trim())
    this.frameTarget.src = `${url.pathname}${url.search}`
  }
}
